import { Card } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { Trophy, Mail, Sparkles } from "lucide-react";
import { apiRequest } from "@/lib/queryClient";

export default function Waitlist() {
  const handleLogout = async () => {
    try {
      await apiRequest('POST', '/api/auth/logout');
    } catch (err) {
      console.error("Logout request failed", err);
    }
    window.location.href = "/";
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-gradient-to-br from-purple-50 via-blue-50 to-white dark:from-gray-900 dark:via-purple-900/20 dark:to-gray-900 p-4">
      <Card className="max-w-2xl w-full p-12 text-center">
        <div className="flex justify-center mb-6">
          <div className="w-20 h-20 bg-primary/10 rounded-full flex items-center justify-center">
            <Trophy className="w-10 h-10 text-primary" />
          </div>
        </div>
        
        <h1 className="text-3xl font-bold mb-4 text-foreground">
          Du bist auf Platz 3 in der Warteliste aufgerückt!
        </h1>
        
        <p className="text-xl text-muted-foreground mb-6">
          Es geht bald los – wir freuen uns schon auf dich!
        </p>
        
        <div className="bg-slate-50 dark:bg-slate-800/50 rounded-lg p-6 mb-8">
          <div className="flex items-center justify-center gap-2 mb-3">
            <Mail className="w-5 h-5 text-primary" />
            <span className="font-semibold text-foreground">Nächster Schritt</span>
          </div>
          <p className="text-muted-foreground text-sm leading-relaxed">
            Du erhältst in Kürze eine E-Mail mit den Zahlungsdetails. 
            Sobald die Zahlung eingegangen ist, schalten wir deinen Zugang frei 
            und du kannst direkt loslegen!
          </p>
        </div>
        
        <div className="flex items-center justify-center gap-2 text-sm text-muted-foreground mb-8">
          <Sparkles className="w-4 h-4 text-amber-500" />
          <span>Wir freuen uns darauf, dich bald im A-Team begrüßen zu dürfen!</span>
        </div>
        
        <Button 
          onClick={handleLogout}
          variant="outline"
          size="lg"
          data-testid="button-logout"
        >
          Abmelden
        </Button>
      </Card>
    </div>
  );
}
